import CaseTasksDashboard from "@/components/Table/CaseTasksDashboard.tsx";
import MrtCaseTableDashboard from "@/components/Table/MrtCaseTableDashboard.tsx";
import { useEmployee } from "@/contexts/EmployeeProvider.tsx";
import { useFetchMrtDashboardTasks } from "@/queries/useFetchMrtDashboardTasks.ts";
import { Box, CircularProgress, Container, Switch, Typography } from "@mui/material";
import { type ReactNode, useEffect, useMemo, useState } from "react";

const HomePage = (): ReactNode => {
    const { employee, isLoading, error } = useEmployee();
    const [taskDashboard, setTaskDashboard] = useState(true);

    const { data } = useFetchMrtDashboardTasks("");

    const teamName = useMemo(() => {
        if (!(error || isLoading) && employee) {
            return employee.team;
        }

        return "";
    }, [employee, error, isLoading]);

    useEffect(() => {
        document.title = "Dashboard";
    }, []);

    useEffect(() => {
        if (data?.data && data?.data.length === 0) {
            setTaskDashboard(false);
        }
    }, [data?.data]);

    return (
        <Container maxWidth={false} sx={{ p: "0 !important" }}>
            <Box display="flex" justifyContent="center" sx={{ width: "100%" }}>
                <Box display="flex" alignItems="center">
                    <Typography variant="body1" sx={{ marginRight: 1 }}>
                        Classic Dashboard
                    </Typography>

                    <Switch
                        color="primary"
                        checked={taskDashboard}
                        onChange={(event) => {
                            setTaskDashboard(event.target.checked);
                        }}
                    />

                    <Typography variant="body1" sx={{ marginLeft: 1 }}>
                        Tasks Dashboard
                    </Typography>
                </Box>
            </Box>
            <Typography variant="h4" mb={2}>
                {teamName} Dashboard
            </Typography>
            {!(taskDashboard || error || isLoading) && employee && (
                <MrtCaseTableDashboard taskDashboard={taskDashboard} />
            )}
            {taskDashboard && !(error || isLoading) && employee && (
                <CaseTasksDashboard taskDashboard={taskDashboard} />
            )}
            {error && employee && <Typography color="error">{error.message}</Typography>}
            {error && !employee && (
                <Typography color="error">
                    You have successfully logged into the Cambre application but there is an issue
                    with your employee record. Please contact an administrator.
                </Typography>
            )}
            {isLoading && <CircularProgress />}
        </Container>
    );
};

export default HomePage;
